<template>
  <div class="info__description">
    <section class="description__item">
      <h3 class="description__title" data-anim="title">{{ data.title }}</h3>

      <p
        class="description__content"
        v-for="paragraph in data.content"
        :key="paragraph"
        v-html="paragraph"
        data-anim="text"
      >
        {{ paragraph }}
      </p>
    </section>

    <section class="description__item u-hidden--until-sm">
      <figure data-parallax="0.2">
        <img v-lazy="switchImg" :alt="data.image.alt">
        <div class="description__image" v-lazy:background-image="switchImg"></div>
      </figure>
    </section>
  </div>
</template>

<script>
export default {
  name: 'InfoIntro',

  props: ['data'],

  computed: {
    switchImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.data.image.src}.webp`;
      }
      return `${this.data.image.src}.jpg`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.info__description {
  position: relative;
  padding: 100px 0 120px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @include mq(sm) {
    padding: 200px 0;
  }

  figure {
    position: relative;
    width: calc(100% + 40px);
    margin: 0 0 0 -40px;
    padding: 0;

    overflow: hidden;

    @include aspect-ratio(5, 4);

    img {
      @include visually-hidden;
    }
  }

  .description__item {
    width: 100%;
    padding: 0 40px;

    @include mq(sm) {
      width: calc(50% - 40px);
      padding: 0;
    }

    .description__title {
      line-height: 1.45;
      font-size: 2.1875rem;
      color: transparent;
      -webkit-text-stroke: 1px $color-light;

      padding-bottom: 80px;
    }

    .description__image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }

    .description__content {
      color: $color-gray;

      @include mq(sm) {
        padding: 0 100px 0 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoDescription.vue